const setCookie = (name, value, hours = 365 * 24, path = '/') => {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    const expires = `; expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}${expires}; path=${path}`;
};

const getCookie = (name) => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.indexOf(`${name}=`) === 0) {
            return cookie.substring(`${name}=`.length, cookie.length);
        }
    }
    return null;
};

window.Cookies = {
    set: setCookie,
    get: getCookie,
};

export default {
    set: setCookie,
    get: getCookie,
}
